import { QueryObserverResult } from '@tanstack/react-query';
import { createContext } from 'react';

import { Remit } from '@/types/billing';
import { InsurancePlan } from '@/types/insurancePlan';
import RepositoryResponse from '@/types/repositoryResponse';

export interface RemitContextInterface {
  remit?: Remit;
  insurancePlans: { [key: string]: InsurancePlan };
  refetch?: () => Promise<QueryObserverResult<RepositoryResponse<Remit>, Error>>;
  highlightServiceLineId?: string | null;
}

const RemitContext = createContext({} as RemitContextInterface);
export default RemitContext;
